module.exports = __webpack_public_path__ + "static/media/career-cover-Tablet.678cfd6f.png";